import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { NavBar } from "../components/NavBar";
import how_it_works_bg from "./imgs/howitworksbg.png";

interface ArticleOptionsPageProps {
  theme: string;
  toggleTheme: any;
}

const ArticleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: url(${how_it_works_bg}) repeat-y center;
  background-size: cover;
  flex-direction: column;
`;

const ArticleOptionsPage = ({
  theme,
  toggleTheme,
}: ArticleOptionsPageProps) => {
  return (
    <>
      <NavBar theme={theme} themeToggler={toggleTheme} />
      <ArticleContainer>
        <Outlet />
      </ArticleContainer>
    </>
  );
};

export default ArticleOptionsPage;
